import './style.scss';
export const ParaRegular = ({ children, className, variant }) => {
  let finalClassName = className
    ? 'jv-para-regular ' + className
    : 'jv-para-regular';
  if (variant === 'semibold') {
    finalClassName += ' semibold';
  }
  if (variant === 'large') {
    finalClassName += ' large';
  }
  return <p className={finalClassName}>{children}</p>;
};
